import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[qpxQuippyBuildingSelector]',
})
export class QuippyBuildingSelectorSlot {
    public readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
